import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '@/layout'


Vue.use(VueRouter);

/**
 * hidden:菜单显隐
 * meta中activeMenu：用户隐藏菜单时，外层菜单仍处于选中状态
 * 权限路由
 */
export const permissionsRoute = [
    {
        path: '/dispatcher-manage',
        component: Layout,
        redirect: '/dispatcher-manage/dispatcher',
        meta: { title: '调度员管理', icon: 'el-icon-s-home' },
        children: [
            {
                path: 'dispatcher',
                component: () => import('@/views/dispatcher-manage/dispatcher'),
                name: 'Dispatcher',
                meta: { title: '调度员列表', roles: ['admin'] },
            },
        ]
    },
    {
        path: '/driver',
        component: Layout,
        redirect: '/driver/drive-base',
        meta: { title: '司机管理', icon: 'el-icon-user-solid', roles: ['admin', 'dispatcher'] },
        children: [
            {
                path: 'drive-base',
                component: () => import('@/views/driver/drive-base'),
                name: 'DriveBase',
                meta: { title: '司机资源库' },
            },
            {
                path: 'detail',
                component: () => import('@/views/driver/drive-base/addEdit'),
                name: 'AddEdit',
                meta: { title: '司机资源库 / 详情', activeMenu: "/driver/drive-base", },
                hidden: true
            },
            {
                path: 'car-base',
                component: () => import('@/views/driver/car-base'),
                name: 'CarBase',
                meta: { title: '车辆资源库' },
            },
            {
                path: 'car-detail',
                component: () => import('@/views/driver/car-base/addEdit'),
                name: 'CarAddEdit',
                meta: { title: '车辆资源库 / 详情', activeMenu: "/driver/car-base", },
                hidden: true
            },
            {
                path: 'cars',
                component: () => import('@/views/driver/cars'),
                name: 'Cars',
                meta: { title: '车辆概览' },
            },
        ]
    },
    {
        path: '/task-manage',
        component: Layout,
        redirect: '/task-manage/task',
        meta: {
            title: '任务管理', icon: 'el-icon-s-order', roles: ['admin', 'dispatcher']
        },
        children: [
            {
                path: 'task',
                component: () => import('@/views/task-manage/task'),
                name: 'Task',
                meta: { title: '配送任务' },
            },
            {
                path: 'add',
                component: () => import('@/views/task-manage/task/add'),
                name: 'Add',
                meta: { title: '配送任务 / 新增', activeMenu: "/task-manage/task", },
                hidden: true
            },
            {
                path: 'detail',
                component: () => import('@/views/task-manage/task/detail'),
                name: 'TaskDetail',
                meta: { title: '配送任务 / 详情', activeMenu: "/task-manage/task", },
                hidden: true
            },
        ]
    },
    {
        path: '/cargo-manage',
        component: Layout,
        redirect: '/cargo-manage/cargo',
        meta: {
            title: '装货管理', icon: 'el-icon-s-help', roles: ['admin', 'dispatcher']
        },
        children: [
            {
                path: 'cargo',
                component: () => import('@/views/cargo-manage/cargo'),
                name: 'Cargo',
                meta: { title: '装货视图' },
            },

        ]
    },
    {
        path: '/external-link',
        component: Layout,
        meta: {
            title: '在途监控', icon: 'el-icon-s-promotion', roles: ['admin', 'dispatcher'], isExternal: true, path: 'http://www.chinamdvr.com:9999/gps-web/h5/outside?userId=江苏莘纳吉&password=670b14728ad9902aecba32e22fa4f6bd&loginType=user&menuId=101'
        },
    },
    {
        path: '/abnormal-manage',
        component: Layout,
        redirect: '/abnormal-manage/event',
        meta: {
            title: '异常管理', icon: 'el-icon-s-unfold', roles: ['admin', 'dispatcher']
        },
        children: [
            {
                path: 'event',
                component: () => import('@/views/abnormal-manage/event'),
                name: 'Event',
                meta: { title: '异常事件' },
            },
            {
                path: 'detail',
                component: () => import('@/views/abnormal-manage/event/detail'),
                name: 'Detail',
                meta: { title: '事件处理', activeMenu: "/abnormal-manage/event" },
                hidden: true
            },
        ]
    },
    {
        path: '/apply-manage',
        component: Layout,
        redirect: '/apply-manage/apply',
        meta: {
            title: '审批管理', icon: 'el-icon-s-data', roles: ['admin', 'dispatcher']
        },
        children: [
            {
                path: 'apply',
                component: () => import('@/views/apply-manage/apply'),
                name: 'Apply',
                meta: { title: '审批管理' },
            },

        ]
    },
    {
        path: '/position-manage',
        component: Layout,
        meta: {
            title: '地理位置', icon: 'el-icon-location', roles: ['admin', 'dispatcher']
        },
        children: [
            {
                path: 'fence',
                component: () => import('@/views/position/fence'),
                name: 'Fence',
                meta: { title: '电子围栏' },
            },
        ]
    },
    {
        path: '/log-manage',
        component: Layout,
        meta: {
            title: '日志管理', icon: 'el-icon-platform-eleme', roles: ['admin', 'dispatcher']
        },
        children: [
            {
                path: 'change-log',
                component: () => import('@/views/log-manage/change-log'),
                name: 'ChangeLog',
                meta: { title: '修改日志' },
            },
            {
                path: 'change-detail',
                component: () => import('@/views/log-manage/change-log/detail'),
                name: 'ChangeDetail',
                meta: { title: '修改日志详情', activeMenu: "/log-managee/change-log" },
                hidden: true
            },
        ]
    },

]



//开放路由
export const openRoute = [
    {
        path: '/',
        redirect: '/login',// 当访问根路径时重定向到登录页
        hidden: true
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/login/login'),
        hidden: true
    },
]



export const allRouter = [
    ...openRoute,
    ...permissionsRoute
]

const createRouter = () => {
    return new VueRouter({
        mode: 'hash',
        routes: openRoute // 初始注册开放路由
    })
}
const router = createRouter()

// 重置路由（用于登出）
export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}



// router.beforeEach((to, from, next) => {
//     let isAuthenticated = true    //判断是否登录
//     if (to.path === '/login' && isAuthenticated) {
//         next('/module'); // 如果用户已登录并试图访问登录页，则重定向到主页
//     }
//     else if (to.path !== '/login' && !isAuthenticated) {
//         next('/login'); // 如果需要认证但用户未登录，则重定向到登录页
//     }
//     else {
//         next(); // 
//     }
// });


export default router;